import { Inject } from '@angular/core';
import templateSource from './view.html';
              import { Component } from '@angular/core';

import Wiz from 'src/wiz';
let wiz = new Wiz('/wiz').app('page.accounting.review');
import { OnInit } from '@angular/core';
import { Service } from "src/libs/portal/season/service";

@Component({
    selector: 'wiz-page-accounting-review',
template: templateSource || '',
    styles: [`

/* file: /mnt/data/wiz/project/main/build/src/app/page.accounting.review/view.scss */
:host {
  display: block;
  height: 100%;
}`],
})
export class PageAccountingReviewComponent implements OnInit {
    constructor(@Inject( Service) public service: Service) { }

    public uploadId: string = '';
    public uploads: any[] = [];
    public transactions: any[] = [];
    public selectedUpload: any = null;

    public txTypeOptions = ['fee', 'expense', 'refund', 'settlement', 'transfer', 'other'];
    public categoryOptions = ['food', 'activity', 'supplies', 'operation', 'other'];
    public directionLabels: any = { in: '입금', out: '출금', transfer: '이체', refund: '환불' };
    public txTypeLabels: any = { fee: '회비', expense: '지출', refund: '환불', settlement: '정산', transfer: '이체', other: '기타' };

    public async ngOnInit() {
        await this.service.init();
        this.uploadId = WizRoute.segment?.uploadId || '';
        if (this.uploadId) {
            await this.loadTransactions(this.uploadId);
        }
        await this.loadUploads();
        await this.service.render();
    }

    public async loadUploads() {
        let res = await wiz.call("uploads");
        if (res.code === 200) this.uploads = res.data || [];
        await this.service.render();
    }

    public async selectUpload(upload: any) {
        this.uploadId = upload.id;
        this.selectedUpload = upload;
        await this.loadTransactions(upload.id);
    }

    public async loadTransactions(uploadId: string) {
        let res = await wiz.call("transactions", { upload_id: uploadId });
        if (res.code === 200) this.transactions = res.data || [];
        let uploadRes = await wiz.call("upload_info", { upload_id: uploadId });
        if (uploadRes.code === 200) this.selectedUpload = uploadRes.data;
        await this.service.render();
    }

    public getConfidenceClass(c: number) {
        if (c >= 0.8) return 'text-green-600';
        if (c >= 0.5) return 'text-yellow-600';
        return 'text-red-600';
    }

    public async updateTx(tx: any, field: string, value: any) {
        let data: any = { id: tx.id };
        data[field] = value;
        await wiz.call("update_transaction", data);
        tx[field] = value;
        await this.service.render();
    }

    public async approveAll() {
        let res = await this.service.modal.show({
            title: '전체 승인',
            message: '모든 거래를 승인하시겠습니까?',
            action: '승인',
            status: 'success'
        });
        if (!res) return;

        let approveRes = await wiz.call("approve", { upload_id: this.uploadId });
        if (approveRes.code === 200) {
            await this.service.modal.show({ title: '완료', message: '승인 완료' });
            await this.loadTransactions(this.uploadId);
        }
    }

    public async reject() {
        let res = await this.service.modal.show({
            title: '반려',
            message: '이 업로드를 반려하시겠습니까?',
            action: '반려',
            status: 'error'
        });
        if (!res) return;

        await wiz.call("reject", { upload_id: this.uploadId });
        await this.loadTransactions(this.uploadId);
    }
}

export default PageAccountingReviewComponent;